import { render, staticRenderFns } from "./GroupSoggetti.vue?vue&type=template&id=4ca85c52"
import script from "./GroupSoggetti.vue?vue&type=script&lang=ts"
export * from "./GroupSoggetti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports